import { buildApiUrl, buildHeaders, handleResponse } from '@/network/api-client';
import type { InventoryApi, InventorySnapshot, GearAdviceResponse } from '../types/inventory.types';
export const inventoryApi: InventoryApi = {
  async snapshot(signal) {
    return handleResponse<InventorySnapshot>(await fetch(buildApiUrl('/hero/inventory'), { headers: buildHeaders(), signal, cache: 'no-store' }));
  },
  async advise(command, signal) {
    return handleResponse<GearAdviceResponse>(await fetch(buildApiUrl('/hero/equipment-advice'), { method: 'POST', headers: buildHeaders(), body: JSON.stringify(command), signal }));
  },
};
